<div class="starsContainer" [class.isEditing]="isEditing()">
	<div class="stars">
		@for (scoreIndex of starsArray(); track $index) {
			@let iconColor = getIconColor(scoreIndex);
			@let fontIcon = iconSet()?.icons?.[scoreIndex]?.icon?.fontIcon;
			@let fontSet = iconSet()?.icons?.[scoreIndex]?.icon?.fontSet;
			@let answerVal = answer();

			<div class="buttonWrapper">
				<button
					mat-icon-button
					color="accent"
					class="starOptionBtn star{{ $index }}"
					matTooltipClass="accent"
					[disabled]="mode() !== AssessablePanelMode.Answer"
					[matTooltipDisabled]="hideScore() || !starScores().length || mode() === AssessablePanelMode.Edit"
					matTooltip="{{ starScores()[scoreIndex] }} {{ T.ASSESSMENT_ITEM_POINTS | translate }}"
					(click)="mode() === AssessablePanelMode.Answer ? onStarClick.emit(scoreIndex) : ''"
					[style.color]="iconColor"
					[class.unanswered]="iconColor ? !inEditMode() && (answerVal === null || answerVal === undefined) : false"
				>
					@let fallbackFontSet = answerVal !== null && scoreIndex <= answerVal ? "fas" : "far";
					<mat-icon [fontSet]="fontSet ?? fallbackFontSet" [fontIcon]="fontIcon ?? 'fa-star'" inline />
				</button>

				<ng-container *ngTemplateOutlet="scoreTemplate(); context: {$implicit: {i: scoreIndex}}" />
			</div>
		}
	</div>
</div>

@if (isEditing()) {
	<div class="actionButtons">
		<button mat-button color="warn" [@zoomInOnEnter] (click)="onRemoveStar.emit()" [disabled]="stars() <= 3">
			<mat-icon class="buttonIcon" fontSet="fad" fontIcon="fa-trash" inline />
			{{ T.ASSESSMENT_PANE_REMOVE_STAR | translate }}
		</button>

		<button mat-button color="accent" [@zoomInOnEnter] (click)="onAddStar.emit()" [disabled]="stars() >= 10">
			<mat-icon class="buttonIcon" fontSet="fad" fontIcon="fa-star" inline />
			{{ T.ASSESSMENT_PANE_ADD_STAR | translate }}
		</button>
	</div>
}
